import { trpc } from '@/utils/trpc'
import { useMemo } from 'react'

type Params = {
  boardId: string
  enabled?: boolean
}
export const useBoardStats = ({ boardId, enabled }: Params) => {
  const { data: boardStats } = trpc.boardStats.useQuery(
    {
      boardId,
    },
    {
      enabled: enabled ?? true,
    },
  )

  const utils = trpc.useUtils()

  const totalNumberOfItems = useMemo(() => {
    if (!boardStats) {
      return 0
    }
    const { inspiration, templates } = boardStats
    const {
      numOfAds: inspirationAdCount,
      numOfEmails: inspirationEmailsCount,
      numOfLandingPages: inspirationLandingPageCount,
    } = inspiration
    const {
      numOfAds: templateAdCount,
      numOfEmails: templateEmailsCount,
      numOfLandingPages: templateLandingPageCount,
    } = templates

    return (
      inspirationAdCount +
      inspirationEmailsCount +
      inspirationLandingPageCount +
      templateAdCount +
      templateEmailsCount +
      templateLandingPageCount
    )
  }, [boardStats])

  const invalidate = (boardId: string) => utils.boardStats.invalidate({ boardId }, { refetchType: 'all' })

  return {
    ...boardStats,
    totalNumberOfItems,
    invalidate,
  }
}
